var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "label-width": "80px",
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("AccountManagement.customer.name"),
                          prop: "cusId",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.customerList,
                            placeholder: _vm.$t("customerNameText"),
                          },
                          model: {
                            value: _vm.queryParams.cusId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "cusId", $$v)
                            },
                            expression: "queryParams.cusId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.Sales"),
                          prop: "csgSales",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: { placeholder: _vm.$t("billingPage.Sales") },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.csgSales,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "csgSales", $$v)
                            },
                            expression: "queryParams.csgSales",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("workOrderList.Customer"),
                          prop: "csgCustomer",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.customerNameList,
                            placeholder: _vm.$t("workOrderList.Customer"),
                          },
                          model: {
                            value: _vm.queryParams.csgCustomer,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "csgCustomer", $$v)
                            },
                            expression: "queryParams.csgCustomer",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("AccountManagement.customer.status"),
                          prop: "enabled",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.STATUS_ENABLED_NUM,
                            placeholder: _vm.$t(
                              "AccountManagement.customer.status"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.enabled,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "enabled", $$v)
                            },
                            expression: "queryParams.enabled",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    col.prop === "enabled"
                                      ? _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_ENABLED_NUM.bjGet(
                                                    scope.row.enabled
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDetail(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("viewText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }